import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchTiposDte = async () => {
  const response = await api.get("/tipoDte");
  return response.data;
};

// Hook reutilizable con React Query
export const useTiposDte = () => {
  return useQuery({
    queryKey: ["tiposDte"],
    queryFn: fetchTiposDte,
  });
};
